module.exports = __webpack_public_path__ + "static/media/ic-switch-acc.ab427eaf.svg";